<template>
  <div class="weui-cell">
    <div class="weui-cell__bd">
      <component :is="view" :to="to" role="button" class="weui-btn_cell" @click="$emit('click')">
        <slot />
      </component>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        to: {
            type: [Object, String],
            default: null,
        },
    },
    computed: {
        view() {
            if (this.to) {
                if (typeof this.to === 'object') {
                    return 'router-link';
                }
            }
            return 'a';
        },
    },
};
</script>

<style lang="scss">
@import '../../../assets/scss/variables';

.weui-btn_cell {
    color: $blue;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/weui/button-cell/Index.vue